import { cloneElement, isValidElement } from 'react';
import { isChildTypeDisplayNameEqualTo } from '@utils/helpers';

const mapPropsToChild = (child, { onClose, disableClose, size }) => {
  if (!isValidElement(child)) {
    return child;
  }

  if (isChildTypeDisplayNameEqualTo(child, 'Header')) {
    return cloneElement(child, { onClose, size, disableClose });
  }

  return cloneElement(child, { size });
};

export default mapPropsToChild;
